import { DetailPageActionTypes } from './constants'
import {
  NormalizeWatchlistToggleType,
  normalizeWatchlistToggle,
} from '../data/normalize'
import {
  actionOnWatchlistToggle,
  WatchlistToggleInputWithoutContext,
} from '../utils/wps'
import { store } from '../store'

type WatchlistPayload = { pageTitleId: string }

export interface IWatchlistToggleAction {
  type: typeof DetailPageActionTypes.WatchlistToggle
  input: WatchlistToggleInputWithoutContext
  output: NormalizeWatchlistToggleType
  payload: WatchlistPayload
}

export interface IWatchlistToggleFailed {
  type: typeof DetailPageActionTypes.WatchlistToggleFailed
  input: WatchlistToggleInputWithoutContext
  payload: WatchlistPayload
}

export interface IClearWatchlistToggleFailure {
  type: typeof DetailPageActionTypes.ClearWatchlistToggleFailure
  payload: WatchlistPayload
}

export const toggleWatchlist = (
  input: WatchlistToggleInputWithoutContext,
  pageTitleId: string
) =>
  actionOnWatchlistToggle(input, output =>
    output
      ? {
          type: DetailPageActionTypes.WatchlistToggle,
          input,
          output: normalizeWatchlistToggle(pageTitleId, output),
          payload: {
            pageTitleId
          }
        }
      : {
          type: DetailPageActionTypes.WatchlistToggleFailed,
          input,
          payload: {
            pageTitleId
          }
        }
  )


export const clearWatchlistFailure = (
  pageTitleId: string
) => {
  store.dispatch({
    type: DetailPageActionTypes.ClearWatchlistToggleFailure,
    payload: {
      pageTitleId
    }
  })
}
